/**
 * DOM HUD: top-left user info box + tiny dev status string.
 */
function fmtCurrency(n: number): string {
  return Math.round(n).toLocaleString('en-US');
}

export class Hud {
  private readonly statusEl: HTMLElement;
  private readonly userInfoEl: HTMLElement;
  private readonly userNameEl: HTMLElement;
  private readonly balanceEl: HTMLElement;

  constructor() {
    const host = document.getElementById('dom-hud');
    if (!host) throw new Error('Hud: #dom-hud missing');

    this.statusEl = document.createElement('div');
    this.statusEl.className = 'hud-status';
    this.statusEl.textContent = 'Loading…';
    host.appendChild(this.statusEl);

    this.userInfoEl = document.createElement('div');
    this.userInfoEl.className = 'user-info';

    this.userNameEl = document.createElement('div');
    this.userNameEl.className = 'ui-user';
    this.userNameEl.textContent = '—';

    this.balanceEl = document.createElement('div');
    this.balanceEl.className = 'ui-balance';
    this.balanceEl.textContent = '0';

    const label = document.createElement('div');
    label.className = 'ui-balance-label';
    label.textContent = 'Balance';

    this.userInfoEl.append(this.userNameEl, this.balanceEl, label);
    host.appendChild(this.userInfoEl);
  }

  setStatus(text: string): void {
    this.statusEl.textContent = text;
  }

  setUserName(userName: string): void {
    this.userNameEl.textContent = userName || '—';
  }

  setBalance(n: number): void {
    this.balanceEl.textContent = fmtCurrency(n);
  }

  setBetTotal(_n: number): void {
    /* no-op — Rive text run carries the visible bet total */
  }
}
